module.exports = __webpack_public_path__ + "img/expand_more.674afce5.svg";